import { NETWORK } from '@/src/helpers';
import { z } from 'zod';

export const oracleSourceSchema = z.object({
  oracle_document_id: z.string(),
  account: z.string(),
});

export type OracleSource = z.infer<typeof oracleSourceSchema>;

export const pricePairOracleSchema = z.object({
  base_asset: z.string(),
  quote_asset: z.string(),
  network: z.custom<NETWORK>(),
  oracles: z.array(oracleSourceSchema),
});

export type PricePairOracle = z.infer<typeof pricePairOracleSchema>;

export const pricePairOraclesSchema = z.array(pricePairOracleSchema);

export type PricePairOracles = z.infer<typeof pricePairOraclesSchema>;

// Form schema that wraps the array for useFieldArray compatibility
export const pricePairOraclesFormSchema = z.object({
  pricePairOracles: pricePairOraclesSchema,
});

export type PricePairOraclesForm = z.infer<typeof pricePairOraclesFormSchema>;
